import { Box, Center, Flex, Text } from '@chakra-ui/react';
import {
  UserNameIcon,
  BirthdayIcon,
  GenderIcon,
  LocationIcon,
  tools,
  CopyIcon,
} from '@halo/ui-chat-react';
import type { User } from '@halo/chat-sdk-react';
import dayjs from 'dayjs';
import { InfoItem } from './InfoItem';
import { Gender } from './Gender';

interface ProfileContentProps {
  user?: User | null;
  countryLabel: string;
}

const ProfileContent = ({ user, countryLabel }: ProfileContentProps) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Text my="2.5" color="fg.muted" fontSize="xs" fontWeight="medium">
        {t('profile.basicInformation')}
      </Text>
      <Box bg="bg.panel" rounded="xl">
        <InfoItem
          icon={<UserNameIcon />}
          label={t('profile.username')}
          extra={
            <Flex
              color="fg.muted"
              cursor="pointer"
              onClick={() => tools.copyToClipboard(`@${user?.username}`)}
              alignItems="center"
              gap="1"
            >
              <Text maxW="200px" truncate>
                @{user?.username}
              </Text>
              <Center fontSize="xs">
                <CopyIcon />
              </Center>
            </Flex>
          }
        />
        <InfoItem
          icon={<BirthdayIcon />}
          label={t('profile.birthday')}
          extra={
            <Text color="fg.muted">
              {user?.birthday ? dayjs(+user?.birthday).format('YYYY-MM-DD') : null}
            </Text>
          }
        />
        <InfoItem
          icon={<GenderIcon />}
          label={t('profile.gender')}
          extra={<Gender gender={user?.gender} />}
        />
        <InfoItem
          icon={<LocationIcon />}
          label={t('profile.location')}
          extra={<Text color="fg.muted">{countryLabel}</Text>}
        />
      </Box>
    </Box>
  );
};

const MemoizedProfileContent = memo(ProfileContent);
export { MemoizedProfileContent as ProfileContent };
